import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { prefix, bsClass, splitBsProps } from './utils/bootstrapUtils';
class PanelFooter extends React.Component {
  render() {
    const {
      children,
      className
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context.$bs_panel || {};
    const [bsProps, elementProps] = splitBsProps(this.props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      className: cn(className, prefix(bsProps, 'footer'))
    }), children);
  }
}
PanelFooter.contextTypes = {
  $bs_panel: PropTypes.shape({
    bsClass: PropTypes.string
  })
};
export default bsClass('panel', PanelFooter);